import type * as Types from '../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PurchaseAiReportsCardMutationVariables = Types.Exact<{
  count: Types.Scalars['Int']['input'];
}>;


export type PurchaseAiReportsCardMutationPage = { readonly __typename?: 'RootMutationType', readonly purchaseAiReportsCard: string };

export type RequestAiReportsBankPaymentMutationVariables = Types.Exact<{
  count: Types.Scalars['Int']['input'];
}>;


export type RequestAiReportsBankPaymentMutationPage = { readonly __typename?: 'RootMutationType', readonly requestAiReportsBankPayment: boolean };


export const PurchaseAiReportsCardDocument = gql`
    mutation PurchaseAiReportsCard($count: Int!) {
  purchaseAiReportsCard(count: $count)
}
    `;
export type PurchaseAiReportsCardMutationFn = Apollo.MutationFunction<PurchaseAiReportsCardMutationPage, PurchaseAiReportsCardMutationVariables>;

/**
 * __usePurchaseAiReportsCardMutation__
 *
 * To run a mutation, you first call `usePurchaseAiReportsCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseAiReportsCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseAiReportsCardMutation, { data, loading, error }] = usePurchaseAiReportsCardMutation({
 *   variables: {
 *      count: // value for 'count'
 *   },
 * });
 */
export function usePurchaseAiReportsCardMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseAiReportsCardMutationPage, PurchaseAiReportsCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseAiReportsCardMutationPage, PurchaseAiReportsCardMutationVariables>(PurchaseAiReportsCardDocument, options);
      }
export type PurchaseAiReportsCardMutationHookResult = ReturnType<typeof usePurchaseAiReportsCardMutation>;
export type PurchaseAiReportsCardMutationResult = Apollo.MutationResult<PurchaseAiReportsCardMutationPage>;
export type PurchaseAiReportsCardMutationOptions = Apollo.BaseMutationOptions<PurchaseAiReportsCardMutationPage, PurchaseAiReportsCardMutationVariables>;
export const RequestAiReportsBankPaymentDocument = gql`
    mutation RequestAiReportsBankPayment($count: Int!) {
  requestAiReportsBankPayment(count: $count)
}
    `;
export type RequestAiReportsBankPaymentMutationFn = Apollo.MutationFunction<RequestAiReportsBankPaymentMutationPage, RequestAiReportsBankPaymentMutationVariables>;

/**
 * __useRequestAiReportsBankPaymentMutation__
 *
 * To run a mutation, you first call `useRequestAiReportsBankPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAiReportsBankPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAiReportsBankPaymentMutation, { data, loading, error }] = useRequestAiReportsBankPaymentMutation({
 *   variables: {
 *      count: // value for 'count'
 *   },
 * });
 */
export function useRequestAiReportsBankPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RequestAiReportsBankPaymentMutationPage, RequestAiReportsBankPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAiReportsBankPaymentMutationPage, RequestAiReportsBankPaymentMutationVariables>(RequestAiReportsBankPaymentDocument, options);
      }
export type RequestAiReportsBankPaymentMutationHookResult = ReturnType<typeof useRequestAiReportsBankPaymentMutation>;
export type RequestAiReportsBankPaymentMutationResult = Apollo.MutationResult<RequestAiReportsBankPaymentMutationPage>;
export type RequestAiReportsBankPaymentMutationOptions = Apollo.BaseMutationOptions<RequestAiReportsBankPaymentMutationPage, RequestAiReportsBankPaymentMutationVariables>;